import React from 'react';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { theme } from 'assets/theme';
import { IDocument } from 'interfaces/document';
import { IUserToken } from 'interfaces/userToken';
import PlusIcon from 'mdi-react/PlusIcon';
import { userRoles } from 'interfaces/user';

interface IProps {
  currentIndex: number;
  lastIndex: number;
  canUpload: boolean;
  classes: any;
  document: IDocument;
  loading: boolean;
  user?: IUserToken;
  onClickReorder: (document: IDocument, upOrDown: '+' | '-') => void;
  showDoubtField: () => void;
  openUploadDialog: () => void;
}

const doubtStyle = { paddingLeft: theme.spacing(1), paddingRight: theme.spacing(1) };

const Header = (
  {
    classes,
    user,
    document,
    loading, showDoubtField, openUploadDialog, onClickReorder, canUpload, currentIndex, lastIndex
  }: IProps) => {

  const canReorder = user && [
    userRoles.admin,
    userRoles.sysAdmin].some(role => user.roles.includes(role));

  return (
    <Box className={classes.header}>
      <Box className={classes.flexRowCentered}>
        {canReorder ? (
          <>
            <IconButton size={'small'} disabled={!(currentIndex > 0)} onClick={() => {
              onClickReorder(document, '+');
            }}>
              <KeyboardArrowUp />
            </IconButton>
            <IconButton size={'small'} disabled={!(currentIndex < lastIndex)} onClick={() => {
              onClickReorder(document, '-');
            }}>
              <KeyboardArrowDown />
            </IconButton>
          </>
        ) : null}
        <Typography variant="subtitle1" className={classes.flexRowCentered}>
          <strong>
            {document.name}
          </strong>
        </Typography>
      </Box>
      <Box>
        <IconButton size="small" onClick={showDoubtField}>
          <Typography variant="button" style={doubtStyle}>?</Typography>
        </IconButton>
        {canUpload && (
          <IconButton color="secondary" disabled={loading} onClick={openUploadDialog}>
            <PlusIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default Header;